/** @jsxImportSource @emotion/react */
"use client";

import { useModal } from "@ebay/nice-modal-react";
import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import type { HighlightsPostPrayer } from "@packages/sdk";
import type { RefObject } from "react";

import { zIndices } from "../../../../../../global/emotion";
import { Button } from "../../../../../components/_base/_core/Button/Button.emotion";
import { ShareModal } from "../../../../../components/_base/modals/ShareModal/ShareModal.emotion";
import type { PostPrayerContentCarouselRef } from "../../data/PostPrayerContentCarousel/PostPrayerContentCarousel.emotion";

const shareOverlayStyle: Interpolation = {
  zIndex: zIndices.overlayOverModal,
};
const shareModalStyle: Interpolation = {
  zIndex: zIndices.modalOverModal,
};

export const PostPrayerHighlightsButton = ({
  subCarouselRef,
  step,
}: {
  subCarouselRef: RefObject<PostPrayerContentCarouselRef>;
  step: HighlightsPostPrayer;
}) => {
  const shareModal = useModal(ShareModal);
  const t = useTranslations();
  return (
    <Button
      onClick={() => {
        const prayerId =
          subCarouselRef.current?.selectedSession?.id ??
          step.sessions[step.sessions.length - 1]?.id;
        const session = step.sessions.find((s) => s.id === prayerId);
        if (session) {
          shareModal.show({
            color: session.images.color_hex ?? "#000",
            imgSrc: session.images,
            title: session.title,
            description: session.label_desc,
            contentCSS: shareModalStyle,
            overlayCSS: shareOverlayStyle,
          });
        }
      }}
    >
      {t("post_prayer_share")}
    </Button>
  );
};
